"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var StackHeaderRight_exports = {};
__export(StackHeaderRight_exports, {
  StackHeaderRight: () => StackHeaderRight,
  appendStackHeaderRightPropsToOptions: () => appendStackHeaderRightPropsToOptions
});
module.exports = __toCommonJS(StackHeaderRight_exports);
var import_children = require("../../headless/children");
function StackHeaderRight(_props) {
  return null;
}
Object.assign(StackHeaderRight, {
  [import_children.NAVIGATOR_CONFIG]: true
});
function appendStackHeaderRightPropsToOptions(options, props) {
  if (!props.asChild) {
    return options;
  }
  return {
    ...options,
    headerRight: function() {
      return props.children;
    }
  };
}
//# sourceMappingURL=StackHeaderRight.js.map
